export default "__VITE_ASSET___fHM7b5N__"